// extracted by mini-css-extract-plugin
export var box = "_5d-0";
export var check = "_5d-1";
export var checkboxButton = "_5d-6";
export var checkboxGroup = "_5d-5";
export var disabled = "_5d-7";
export var ghost = "_5d-9";
export var input = "_5d-2";
export var label = "_5d-4";
export var normal = "_5d-8";
export var uncheck = "_5d-3";